import React from 'react'
import UserManagement from '../../../components/AdminUserManagement/UserManagement'

const UserManagementPage = () => {
  return (
    <div className="w-full">
      <UserManagement/>
    </div>
  )
}

export default UserManagementPage
